import mutations from './myHomeMutation'
import actions from './myHomeAction'
import getters from './myHomeGetter'

const state= {
  projectList: [],
  workRequestList: [],
  noticeList: [],
  qnaList: [],
}

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/vuex/home/myHomeStore.js